import { useStore } from '@nanostores/react'
import { getTrialEligibility } from '~/helpers/trial-eligibility'
import { platform } from '~/params'
import { $annualEarlyBirdProduct, $chinaAndroidTrialEligibility } from '~/store'

export function useTrialEligibility() {
  const product = useStore($annualEarlyBirdProduct)
  const chinaAndroidTrialEligibility = useStore($chinaAndroidTrialEligibility)
  return getTrialEligibility(platform, chinaAndroidTrialEligibility, product)
}
